import { render, staticRenderFns } from "./InformeDetalhe.vue?vue&type=template&id=638bb3b0&scoped=true&"
import script from "./InformeDetalhe.vue?vue&type=script&lang=js&"
export * from "./InformeDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./InformeDetalhe.vue?vue&type=style&index=0&id=638bb3b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638bb3b0",
  null
  
)

export default component.exports